// Add your custom JS here.
import Headroom from 'headroom.js';
import ScrollReveal from 'scrollreveal';
import $ from 'jquery';
// Grab an element
var myElement = document.querySelector("header");

// Construct an instance of Headroom, passing the element
var headroom = new Headroom(myElement);

// Initialise Headroom
headroom.init();

// Define slide up animation options
var slideUp = {
    distance: '0px',
    opacity: 0,
    duration: 1000,
    delay: 200
};

// Reveal elements with the "scrollimation" class using slide up animation
ScrollReveal().reveal('.scrollimation', slideUp);

// Handle scroll event
$(window).on('scroll', function () {
    // For each element with the "slide-up" class
    $('.slide-up').each(function () {
        var slideUpPos = $(this).offset().top;
        var slideUpScroll = slideUpPos - $(window).height() + 200; // Adjust the offset as needed

        // If the window is scrolled past the element's position
        if ($(window).scrollTop() > slideUpScroll) {
            $(this).fadeIn();
        }
    });
});

$(window).on('load', function () {
    $('#baumKoventionModal').modal('show');
});



function getFooterHeight() {
    const footer = document.querySelector('#site-footer');
    const footerHeight = footer.offsetHeight;
    document.documentElement.style.setProperty('--footer-height', footerHeight + 'px');
    // console.log('--footer-height' + footerHeight + 'px')
}

$(function () {
    var toggleBtn = $('.navbar-toggler');
    const header = document.querySelector('header');
    let timeout;

    getFooterHeight();


    $(document.window).on('resize', getFooterHeight);



    // Handle click event for toggle button
    toggleBtn.on('click', function () {
        $('html').toggleClass('menu-active');
        $(this).toggleClass('toggle-active');
    });

    var menuItems = $('.navbar .nav-item');

    // Handle click event for menu items
    menuItems.on('click', function () {
        $('html').removeClass('menu-active');
        $('.navbar-toggler').removeClass('toggle-active');
        $("#navbarSupportedContent").removeClass('show')
    });



    $('.team .btn-link').on('click', function () {
        $(this).siblings('p').children('.points').toggleClass('d-none');
    });

    // myCollapsible.addEventListener('hidden.bs.collapse', function () {
    //     // do something...
    // })

});


document.addEventListener('DOMContentLoaded', function () {
    const orderPage = document.querySelector('.page-id-848');


    if (orderPage) {
        const stueckzahlField = document.querySelector('select[name="bestellmenge"]');
        const totalCosts = document.querySelector('input[name="total-costs"]');

        const gesamtkostenElement = document.getElementById('gesamtkosten');
        console.log(gesamtkostenElement, 'gesamtkosten');

        const kostenProStueck = 3.00;
        const verpackungUndVersand = 6.00;

        function updateGesamtkosten() {
            const selectedValue = parseInt(stueckzahlField.value, 10);
            console.log(selectedValue, 'selectedValue');
            const gesamtkosten = selectedValue * kostenProStueck + verpackungUndVersand;
            if (isNaN(selectedValue)  || selectedValue < 1 || selectedValue > 8) {
                gesamtkostenElement.textContent = 'Bitte Stückzahl wählen';
                totalCosts.textContent = 'Bitte Stückzahl wählen';
            }
            else {
                console.log(gesamtkosten, 'gesamtkosten');
                gesamtkostenElement.textContent = ` € ${gesamtkosten.toFixed(2)}`;
                totalCosts.textContent = ` € ${gesamtkosten.toFixed(2)}`;
                totalCosts.value = ` € ${gesamtkosten.toFixed(2)}`;
            }
        }

        if (stueckzahlField) {
            console.log(stueckzahlField, 'stueckzahlField');
            updateGesamtkosten();
            stueckzahlField.addEventListener('change', updateGesamtkosten);
        }
    }
});